"use client";
import { create } from "zustand";

// Define the store type
interface SearchStore {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

// Create the Zustand store
export const useSearchStore = create<SearchStore>((set) => ({
  searchTerm: "",
  setSearchTerm: (term) => set({ searchTerm: term }),
}));
